import { useContactUsEmailStorage } from "@/components/support/contactUs/email/contact-us-email-storage";
import { cn } from "@/libs/utils";
import { ContactUsSchemaType } from "@/schemas/contact-us";
import { useTrans } from "@/utils/useTrans";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/v2-components/ui/form";
import ChevronDownIcon from "@/v2-components/core/icon/chevron-down-icon";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/v2-components/ui/select";
import { Fragment, useEffect } from "react";
import { useFormContext } from "react-hook-form";

export const categories = [
  { id: "device-tactsuit-pro", label: "Device, Tactsuit Pro" },
  { id: "device-tactsuit-air", label: "Device, Tactsuit Air" },
  { id: "device-tactsleeve", label: "Device, TactSleeve" },
  { id: "device-tactvisor", label: "Device, TactVisor" },
  { id: "device-tactglove", label: "Device, TactGlove" },
  { id: "device-tactsuit-x40", label: "Device, Tactsuit X40" },
  { id: "device-tactsuit-x16", label: "Device, Tactsuit X16" },
  { id: "device-tactosy-for-arms", label: "Device, Tactosy for arms" },
  { id: "device-tactosy-for-feet", label: "Device, Tactosy for feet" },
  { id: "order", label: "Order" },
  { id: "game-software", label: "Game & Software" },
  { id: "others", label: "Others" },
];

export default function CategorySelect() {
  const { t } = useTrans(["support"]);

  const form = useFormContext<ContactUsSchemaType>();
  const contactUsEmailStorage = useContactUsEmailStorage();

  return (
    <FormField
      control={form.control}
      name="category"
      defaultValue={form.watch("category")}
      render={({ field }) => (
        <FormItem className="w-full space-y-2">
          <FormLabel variant="select">
            <span>{t("Category")}</span>
            <span>{" *"}</span>
          </FormLabel>
          <Select
            onValueChange={(value) => {
              field.onChange(value);
              form.setValue("topic", "");
              contactUsEmailStorage.set(form.getValues());
            }}
            value={field.value}
          >
            <FormControl>
              <SelectTrigger variant="form">
                <SelectValue placeholder={t("Choose a category")} />
                <ChevronDownIcon />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {categories.map((category, index) => (
                <Fragment key={category.id}>
                  <SelectItem value={category.id}>{category.label}</SelectItem>
                  <SelectSeparator
                    className={cn(index === categories.length - 1 && "hidden")}
                  />
                </Fragment>
              ))}
            </SelectContent>
          </Select>
          <FormMessage t={t} />
        </FormItem>
      )}
    />
  );
}
